export default __webpack_public_path__ + "static/media/validado.558bb342.svg";